import { formatNumber } from "helpers/system";
import React from "react";

export default function MonthResult(props) {
    const { data } = props;

    const renderCell = (cell, isInverted = false, note = null) => {
        let cName = null;
        let diff = null;

        if (cell?.diff != null) {
            diff = (cell.diff > 0 ? "+" : "") + formatNumber(cell.diff) + (cell.diffSign ?? "");

            if (cell.diff === 0) {
                cName = "a-report__table--gray";
            } else if (cell.diff > 0 && !isInverted) {
                cName = "a-report__table--green";
            } else {
                cName = "a-report__table--red";
            }

            diff = `(${diff})`;
        }

        return (
            <td className="a-report__table--noborder-right a-report__table--noborder-left">
                {formatNumber(cell?.value)}&nbsp;
                <span className={cName}>{diff}</span>
                {!!note && (
                    <>
                        <br /> <small className="text-muted">{note}</small>
                    </>
                )}
            </td>
        );
    };

    return (
        <div className="pb-2">
            <div className="a-report__text-block">
                <div className="a-report__title">Итоги месяца: {data.month}</div>
                <div className="pb-2">
                    Компания: <strong>{data.organizationName}</strong>
                </div>
                <div className="a-report__warning-card mb-1">
                    <p>
                        <strong>Внимание!</strong> Данные актуальны на момент получения письма и формируются из данных
                        отчетов в системе.
                    </p>
                    На корректность данных влияют:
                    <ul className="mb-1">
                        <li>Корректность плановых маршрутов;</li>
                        <li>Своевременность создания заявок (до начала выполнения рейса);</li>
                        <li>Своевременность закрытия рейсов (корректные адреса загрузок и выгрузок);</li>
                        <li>Корректная работа GPS трекеров и своевременная актуализация.</li>
                    </ul>
                </div>
            </div>
            <br />
            <div className="a-report__text-block no-page-break">
                <div className="a-report__text-link pb-3 font-size-18">Ключевые показатели и их изменения</div>
                <div>
                    <table className="a-report__table mb-3">
                        <thead>
                            <tr>
                                <th className="a-report__table--noborder-left a-report__table--noborder-top font-weight-semibold">
                                    Показатель
                                </th>
                                <th className="a-report__table--noborder-top a-report__table--noborder-right font-weight-semibold">
                                    Значение
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="a-report__table--noborder-left">Количество активных ТС</td>
                                {renderCell(data.mainData.carsCount)}
                            </tr>
                            <tr>
                                <td className="a-report__table--noborder-left">Руб/км</td>
                                {renderCell(data.mainData.outputPerKm)}
                            </tr>
                            <tr>
                                <td className="a-report__table--noborder-left">Руб/час</td>
                                {renderCell(data.mainData.outputPerHour)}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br />
            <div className="a-report__text-block no-page-break">
                <div>
                    <table className="a-report__table my-3">
                        <thead>
                            <tr>
                                <th className="a-report__table--noborder-left a-report__table--noborder-top font-weight-semibold">
                                    Показатель
                                </th>
                                <th className="a-report__table--noborder-top a-report__table--noborder-right font-weight-semibold">
                                    На парк
                                </th>
                                <th className="a-report__table--noborder-top a-report__table--noborder-left a-report__table--noborder-right font-weight-semibold">
                                    Среднее на ТС
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="a-report__table--noborder-left">Общий пробег, км</td>
                                {renderCell(data.mainData.overallMileage)}
                                {renderCell(data.mainData.averageOverallMileage)}
                            </tr>
                            <tr>
                                <td className="a-report__table--noborder-left">Активный пробег, км</td>
                                {renderCell(data.mainData.activeMileage)}
                                {renderCell(data.mainData.averageActiveMileage)}
                            </tr>
                            <tr>
                                <td className="a-report__table--noborder-left">
                                    Порожний пробег (по заявкам и без заявок), км
                                </td>
                                {renderCell(data.mainData.emptyMileage)}
                                {renderCell(data.mainData.averageEmptyMileage, true)}
                            </tr>
                            <tr>
                                <td className="a-report__table--noborder-left">Вал, с НДС, руб</td>
                                {renderCell(data.mainData.bidsPrice)}
                                {renderCell(data.mainData.averageBidsPrice)}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br />
            <div className="a-report__text-block no-page-break">
                <div className="a-report__text-link pb-3 font-size-18">Точки роста и их изменения</div>
                <div>
                    <table className="a-report__table mb-3">
                        <thead>
                            <tr>
                                <th className="a-report__table--noborder-left a-report__table--noborder-top font-weight-semibold">
                                    Показатель
                                </th>
                                <th className="a-report__table--noborder-top a-report__table--noborder-right font-weight-semibold">
                                    На парк
                                </th>
                                <th className="a-report__table--noborder-top a-report__table--noborder-left a-report__table--noborder-right font-weight-semibold">
                                    Финансовый эффект
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="a-report__table--noborder-left">Порожний пробег, км</td>
                                {renderCell(data.financeData.emptyMileage, true)}
                                {renderCell(
                                    data.financeData.emptyMileageEffect,
                                    true,
                                    "(Изменение порожнего пробега * себестоимость 1 км)",
                                )}
                            </tr>
                            <tr>
                                <td className="a-report__table--noborder-left">Перепробег, км</td>
                                {renderCell(data.financeData.excessMileage, true)}
                                {renderCell(
                                    data.financeData.excessMileageEffect,
                                    true,
                                    "(Изменение пробега * себестоимость 1 км)",
                                )}
                            </tr>
                            <tr>
                                <td className="a-report__table--noborder-left">
                                    Среднее время погрузочно-разгрузочных работ, ч
                                </td>
                                {renderCell(data.financeData.averageLoadUnloadTime)}
                                {renderCell(
                                    data.financeData.averageLoadUnloadTimeEffect,
                                    true,
                                    "(Общее количество загрузок и выгрузок в месяц * Значение изменения * руб/час)",
                                )}
                            </tr>
                            <tr>
                                <td className="a-report__table--noborder-left">Межзаявочный интервал, ч</td>
                                {renderCell(data.financeData.interBidInterval, true)}
                                {renderCell(
                                    data.financeData.interBidIntervalEffect,
                                    true,
                                    "(Общее количество заявок в месяц делить на 2 и * Значение изменения * руб/час)",
                                )}
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    Пояснение к цветам (финансовый эффект):
                    <ul>
                        <li>
                            Для финансового эффекта: уменьшение (минус) - это хорошо{" "}
                            <span className="a-report__table--green">✓</span>
                        </li>
                        <li>
                            <span className="a-report__table--red">Красный цвет</span> - негативное изменение
                        </li>
                        <li>
                            <span className="a-report__table--green">Зеленый цвет</span> - позитивное изменение
                        </li>
                    </ul>
                    Как считается себестоимость на 1км:
                    <ul>
                        <li>1 км = Руб/км - 10%</li>
                    </ul>
                </div>
            </div>
            <br />
            <div className="a-report__text-block no-page-break">
                <div className="a-report__text-link pb-3 font-size-18 pt-1">Описание отчета</div>
                <div className="pb-2">
                    <div>
                        <strong>Порожний пробег</strong> — это километры без полезной нагрузки. Мы сравниваем текущий и
                        прошлый месяц и показываем разницу.
                        <br />
                        Польза: снижение порожнего пробега уменьшает затраты на топливо и амортизацию.
                    </div>
                    <br />
                    <div>
                        <strong>Перепробег</strong> — разница между плановым и фактическим пробегом. В отчёте отражено
                        изменение относительно прошлого месяца.
                        <br />
                        Польза: чем меньше перепробег, тем точнее планирование и ниже расходы на рейс.
                    </div>
                    <br />
                    <div>
                        <strong>Среднее время погрузочно-разгрузочных работ</strong> — рассчитывается по данным отчёта
                        по ПРР.
                        <br />
                        Польза: уменьшение времени ПРР увеличивает оборачиваемость транспорта.
                    </div>
                    <br />
                    <div>
                        <strong>Межзаявочный интервал</strong> — среднее время простоя транспорта между заявками.
                        <br />
                        Польза: сокращение интервала повышает загрузку парка и уменьшает себестоимость часа.
                    </div>
                </div>
            </div>
            <br />
        </div>
    );
}
